module.exports = __webpack_public_path__ + "static/evaksine_logo-2ce23c63a1b1826b01853ae72ec827b6.png";